export const generateErrorMessage = (action, entity) => {
    return `Failed ${action} ${entity}`;
  };
  